<template>
  <div>
    <div class="list">
      <user-item v-for="user in visibleUsers" :id="user.id" :key="user.id">
        <template #default="{ user }">
          <router-link :to="`/user/${user.id}`" class="user">
            <div
              v-lazy:background-image="{
                src: user.profile_photo_thumb_url || '/placeholder/profile_photo.svg',
                error: '/placeholder/profile_photo.svg',
                loading: '/placeholder/profile_photo.svg'
              }"
              class="user-thumb"
            />
            <br />
            <span class="username">{{ user.firstname }}</span>
          </router-link>
        </template>
      </user-item>
    </div>

    <router-link v-if="showAllLink" class="tw-text-sm tw-text-riser-blue" :to="showAllLink">
      {{ $t('Show-all') }}
    </router-link>
  </div>
</template>

<script>
import UserItem from '~/components/user'

export default {
  name: 'UsersList',
  components: {
    UserItem
  },
  props: {
    users: {
      type: Array,
      default: []
    },
    showAllLink: {
      type: String
    },
    visibleUsersCount: {
      type: Number,
      default: 5
    }
  },
  computed: {
    visibleUsers() {
      return this.users.slice(-this.visibleUsersCount)
    }
  }
}
</script>

<style lang="sass" scoped>
@import "@/assets/vars.sass"

.list
  display: flex
  flex-wrap: nowrap
  justify-content: flex-start

.user
  display: block
  text-align: center
  margin: $padding

.username
  font-weight: bold
  font-size: 0.8em
  text-align: center
  overflow: hidden
  text-overflow: ellipsis
</style>
